import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {paths} from "@/lib/paths";
import {getSession} from "@zaaaz/shared";
import {useI18n} from "./I18nProvider";

function hasCookie(): boolean {
  if(typeof document === "undefined") return true;
  return document.cookie.split(";").some((c) => c.trim().startsWith("cookies="));
}

export function CookieBanner() {
  const {t} = useI18n();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if(hasCookie()) return;
    getSession().then((u) => { if(u.authenticated) setShow(true); }).catch(() => {});
  }, []);
  if(!show) return null;
  function dismiss() {
    const maxAge = 60 * 60 * 24 * 365;
    document.cookie = `cookies=1; path=/; max-age=${maxAge}; SameSite=Lax`;
    setShow(false);
  }
  return (
    <div id="cookiesBar">
      <div className="inside">
        <p>
          {t("This site uses cookies. By continuing to browse this site, you agree to the use of cookies.")}{" "}
          <Link to={paths.privacy} className="anim">{t("More details...")}</Link>
        </p>
        <i className="fa fa-times" onClick={dismiss} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && dismiss()} />
      </div>
    </div>
  );
}
